import React from 'react';
import BaseTableCard from 'components/atoms/base-table-card';
import BaseGrid from 'components/atoms/base-grid';
import { useTranslation } from 'react-i18next';

import { useAgencyDoctorViewForm } from './hook';
import AgencyDoctorHeaderInfo from '../header-info';

import type { AgencyDoctor } from 'infrastructure/classes/agency-doctor';

interface IProps {
  info: AgencyDoctor;
}

const AgencyDoctorViewForm: React.FC<IProps> = (props) => {
  const { info } = props;

  const { t } = useTranslation();

  const {
    personalInfo,
    professionInfo,
    addressInfo,
    registrationInfo,
    irsInfo,
  } = useAgencyDoctorViewForm({
    info,
  });

  return (
    <BaseGrid rowGap={40}>
      <AgencyDoctorHeaderInfo info={info} />
      <BaseGrid columns={2} columnGap={20}>
        <BaseTableCard title={t('labels.personalInfo')} items={personalInfo} />
        <BaseGrid rowGap={20}>
          <BaseTableCard
            title={t('labels.professionInfo')}
            items={professionInfo}
          />
          <BaseTableCard
            title={t('labels.registration')}
            items={registrationInfo}
          />
        </BaseGrid>
      </BaseGrid>
      <BaseGrid columns={2} columnGap={20}>
        <BaseTableCard title={t('labels.address')} items={addressInfo} />
        <BaseTableCard title={t('labels.irs')} items={irsInfo} />
      </BaseGrid>
    </BaseGrid>
  );
};

export default AgencyDoctorViewForm;
